@if (isMultiLanguage()) {
    <div [ngClass]="'language selected-' + getCurrentLanguage() + ' '" dropdown>
        @if (isLargeBreakpoint) {
            <button
                [core-analytics]="{ action: 'toggle-dropdown', block }"
                class="btn btn--country-language-selector"
                type="button"
                id="language-button"
                dropdownToggle
                aria-haspopup="menu"
                [attr.aria-expanded]="null"
                [attr.aria-controls]="'basic-link-dropdown'">
                @if (showFlags) {
                    <div class="language-icon-wrapper">
                        <span [ngClass]="'language-icon language-icon--' + getCurrentLanguage()"></span>
                    </div>
                } @else {
                    <div class="language-icon-wrapper language-icon-wrapper--no-border">
                        <svg
                            fill="none"
                            height="22"
                            viewBox="0 0 23 22"
                            width="23"
                            xmlns="http://www.w3.org/2000/svg"
                            stroke="currentColor"
                            aria-hidden="true"
                            focusable="false">
                            <path
                                d="M11.9961 20.1672C17.0587 20.1672 21.1627 16.0631 21.1627 11.0005C21.1627 5.93789 17.0587 1.83383 11.9961 1.83383C6.93346 1.83383 2.82941 5.93789 2.82941 11.0005C2.82941 16.0631 6.93346 20.1672 11.9961 20.1672Z"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.7"></path>
                            <path
                                d="M2.82941 11.0005H21.1627"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.7"></path>
                            <path
                                d="M11.9961 1.83383C14.2889 4.34399 15.5919 7.60153 15.6627 11.0005C15.5919 14.3995 14.2889 17.657 11.9961 20.1672C9.70323 17.657 8.40022 14.3995 8.32941 11.0005C8.40022 7.60153 9.70323 4.34399 11.9961 1.83383Z"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.7"></path>
                        </svg>
                    </div>
                }
                <span class="country-language">
                    <span [innerText]="'Language' | translate" class="country-language__label"></span>
                    @if (isMultiLanguage()) {
                        <div
                            [innerText]="getLanguageName(getCurrentLanguage()) | translate"
                            class="country-language__name"></div>
                    }
                </span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    class="language-btn__arrow"
                    aria-hidden="true"
                    focusable="false">
                    <path
                        d="M4 6L8 10L12 6"
                        stroke="white"
                        stroke-width="1.33333"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>
        }

        @if (!isLargeBreakpoint) {
            <button
                [core-analytics]="{ action: 'toggle-dropdown', block }"
                class="language-btn"
                type="button"
                id="language-button"
                dropdownToggle
                aria-haspopup="menu"
                [attr.aria-expanded]="null"
                [attr.aria-label]="
                    ('Select language' | translate) + ': ' + (getLanguageName(getCurrentLanguage()) | translate)
                "
                [attr.aria-controls]="'basic-link-dropdown'">
                @if (showFlags) {
                    <div class="language-icon-wrapper">
                        <span [ngClass]="'language-icon language-icon--' + getCurrentLanguage()"></span>
                    </div>
                } @else {
                    <div class="language-icon-wrapper language-icon-wrapper--no-border">
                        <svg
                            fill="none"
                            height="22"
                            viewBox="0 0 23 22"
                            width="23"
                            xmlns="http://www.w3.org/2000/svg"
                            stroke="currentColor"
                            aria-hidden="true"
                            focusable="false">
                            <path
                                d="M11.9961 20.1672C17.0587 20.1672 21.1627 16.0631 21.1627 11.0005C21.1627 5.93789 17.0587 1.83383 11.9961 1.83383C6.93346 1.83383 2.82941 5.93789 2.82941 11.0005C2.82941 16.0631 6.93346 20.1672 11.9961 20.1672Z"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.7"></path>
                            <path
                                d="M2.82941 11.0005H21.1627"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.7"></path>
                            <path
                                d="M11.9961 1.83383C14.2889 4.34399 15.5919 7.60153 15.6627 11.0005C15.5919 14.3995 14.2889 17.657 11.9961 20.1672C9.70323 17.657 8.40022 14.3995 8.32941 11.0005C8.40022 7.60153 9.70323 4.34399 11.9961 1.83383Z"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.7"></path>
                        </svg>
                    </div>
                }
                <svg
                    class="language-btn__arrow"
                    fill="none"
                    height="7"
                    viewBox="0 0 11 7"
                    width="11"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false">
                    <path
                        [attr.fill]="languageCurrentColor"
                        d="M5.07672 4.43901L8.78526 0.677043C8.95052 0.509312 9.21495 0.511023 9.38021 0.680466L10.0297 1.3531C10.195 1.52597 10.195 1.80324 10.028 1.97439L5.37585 6.76157C5.29322 6.84715 5.1858 6.88993 5.07672 6.88993C4.96765 6.88993 4.86022 6.84715 4.77759 6.76157L0.125395 1.97439C-0.0415219 1.80324 -0.0415219 1.52597 0.123743 1.3531L0.773232 0.680466C0.938497 0.511023 1.20292 0.509312 1.36818 0.677043L5.07672 4.43901Z" />
                </svg>
            </button>
        }

        <ul
            *dropdownMenu
            class="dropdown-menu dropdown-menu--language"
            id="basic-link-dropdown"
            role="menu"
            aria-labelledby="language-button">
            @for (language of languages$; track language.code) {
                <li
                    (click)="setLanguage(language)"
                    (keydown.enter)="setLanguage(language)"
                    (keydown.space)="setLanguage(language); $event.preventDefault()"
                    [ngClass]="getLanguageItemClasses(language.code)"
                    class="language-item"
                    role="menuitem"
                    tabindex="0">
                    @if (showFlags) {
                        <div class="language-icon-wrapper">
                            <span class="language-icon"></span>
                        </div>
                    }
                    <span [innerText]="language.name | translate" class="language-item__name"></span>
                </li>
            }
            <!--    <li class="language-item">-->
            <!--      <span class="powered-by">-->
            <!--        Powered by <strong>DEEPL</strong>-->
            <!--      </span>-->
            <!--    </li>-->
        </ul>
    </div>
}

@if (isMultiLanguage() && !isLargeBreakpoint) {
    <div
        [innerText]="getLanguageName(getCurrentLanguage()) | translate"
        class="language-current text-uppercase"
        [style.color]="languageCurrentColor"></div>
}

<ng-template #languageSelect>
    <div class="modal-header language-modal-header">
        <h5>{{ 'Select your language' | translate }}</h5>
    </div>
    <div class="modal-body">
        @for (language of languages$; track language.code) {
            <div [ngClass]="{ active: language.code === '' }" class="mb-3">
                <a
                    (click)="setLanguage(language)"
                    [core-analytics]="{ action: language.name, block }"
                    [innerText]="language.name"
                    class="btn btn--country"
                    href="javascript:void(0)"></a>
            </div>
        }
    </div>
</ng-template>
